import { useTranslation } from 'react-i18next';

import { useTheme } from '../../app/ThemeProvider';

/** Sun/moon theme toggle in the header (§25.2). Persists via ThemeProvider. */
export function ThemeToggle({ className = '' }: { className?: string }) {
  const { theme, toggleTheme } = useTheme();
  const { t } = useTranslation();

  const nextMode = theme === 'dark' ? t('theme.light') : t('theme.dark');

  return (
    <button
      type="button"
      onClick={toggleTheme}
      aria-label={t('a11y.toggleTheme', { mode: nextMode })}
      className={`inline-flex h-9 w-9 items-center justify-center rounded-pill border border-line text-content transition-colors hover:bg-content/5 ${className}`}
    >
      <span aria-hidden="true" className="text-base leading-none">
        {theme === 'dark' ? '☀' : '☾'}
      </span>
    </button>
  );
}
